import React from "react";

class ImageModal extends React.Component {
  render() {
    return (
      <div
        id="active-image-modal"
        className="modal-image valign-wrapper"
        onClick={() => this.props.setActiveImage("")}
      >
        <img
          className="modal-content"
          id="active-image"
          src={this.props.active_image_url}
          alt="selected_Image"
        />
      </div>
    );
  }
}
export default ImageModal;



// WEBPACK FOOTER //
// ./src/components/ImageModal.js